module.exports = __webpack_public_path__ + "media/KZ-VOS.acf191fa.ogg";